export enum CandidateEmailType {
  Personal,
  Work,
  Other,
}
export enum CandidateLinkType {
  Blog,
  Company,
  Job_Posting,
  Other,
  Personal,
  Portfolio,
  Social_Media,
}
export enum CandidatePhoneNumberType {
  Home,
  Mobile,
  Other,
  Skype,
  Work,
}
export enum CandidateReviewHelpfulnessType {
  Helpful,
  NotHelpful,
}
export enum CandidateImportSource {
  CSV,
  LeadForm,
  Merge,
  EventRsvp,
  ProfileEdit,
  Manual,
  CsvUpdate,
  Rollback,
  StatusChange,
}
